(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mia-faq"] && !Shopify.designMode) return;
  try {
    
  /* Category filter buttons (FAQ / News): toggle buttons with aria-pressed + a polite status line.
     Shared with mia-news.liquid (identical copy); the window guard keeps one instance. */
  (function () {
    if (window.miaFilterTabs) return;
    window.miaFilterTabs = true;
    function init(root) {
      if (root.getAttribute('data-mia-filter-tabs-ready')) return;
      root.setAttribute('data-mia-filter-tabs-ready', '1');
      var buttons = root.querySelectorAll('[data-tab]');
      var items = root.querySelectorAll('[data-tab-item]');
      var empty = root.querySelector('[data-tab-empty]');
      var status = root.querySelector('[data-tab-status]');
      function select(val, announce) {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tab') === val ? 'true' : 'false'); });
        var n = 0;
        items.forEach(function (it) {
          var cats = (it.getAttribute('data-tab-item') || '').split('|');
          var show = val === 'all' || cats.indexOf(val) > -1;
          it.hidden = !show; if (show) n++;
        });
        if (empty) empty.hidden = n > 0;
        if (status && announce) {
          var tpl = (n === 1 && status.getAttribute('data-one')) || status.getAttribute('data-other') || '';
          status.textContent = tpl.replace('__COUNT__', String(n));
        }
      }
      buttons.forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-tab'), true); }); });
      select('all', false);
    }
    function all(scope) { (scope || document).querySelectorAll('[data-mia-filter-tabs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mia-news"] && !Shopify.designMode) return;
  try {
    
  /* Category filter buttons (FAQ / News) — same code as mia-faq.liquid; the window guard keeps one instance. */
  (function () {
    if (window.miaFilterTabs) return;
    window.miaFilterTabs = true;
    function init(root) {
      if (root.getAttribute('data-mia-filter-tabs-ready')) return;
      root.setAttribute('data-mia-filter-tabs-ready', '1');
      var buttons = root.querySelectorAll('[data-tab]');
      var items = root.querySelectorAll('[data-tab-item]');
      var empty = root.querySelector('[data-tab-empty]');
      var status = root.querySelector('[data-tab-status]');
      function select(val, announce) {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tab') === val ? 'true' : 'false'); });
        var n = 0;
        items.forEach(function (it) {
          var cats = (it.getAttribute('data-tab-item') || '').split('|');
          var show = val === 'all' || cats.indexOf(val) > -1;
          it.hidden = !show; if (show) n++;
        });
        if (empty) empty.hidden = n > 0;
        if (status && announce) {
          var tpl = (n === 1 && status.getAttribute('data-one')) || status.getAttribute('data-other') || '';
          status.textContent = tpl.replace('__COUNT__', String(n));
        }
      }
      buttons.forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-tab'), true); }); });
      select('all', false);
    }
    function all(scope) { (scope || document).querySelectorAll('[data-mia-filter-tabs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
